/**
 * Logo component.
 * @module components/theme/Logo/Logo
 */

import React from 'react';
import { Link } from 'react-router-dom';

import { Image } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import config from '@plone/volto/registry';

import LogoImage from '@package/components/layout/images/logo.svg';
import logoExtra from '@package/components/layout/images/AgriECO.svg';

/**
 * Logo component class.
 * @function Logo
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component.
 */
const Logo = () => {
  const { settings } = config;
  const lang = useSelector((state) => state.intl.locale);

  return (
    <Link to={settings.isMultilingual ? `/${lang}` : '/'} title="AgriECO">
      <Image
        className="logo-cariplo"
        src={LogoImage}
        alt="Fondazione Cariplo logo"
        title="Fondazione Cariplo logo"
        height={60}
      />
      <Image
        className="logo-agrieco"
        src={logoExtra}
        alt="AgriECO logo"
        title="AgriECO logo"
        height={30}
      />
    </Link>
  );
};

export default Logo;
